var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.08008C11.8218 1.08008 14.9199 4.17819 14.9199 8C14.9199 11.8218 11.8218 14.9199 8 14.9199C4.17819 14.9199 1.08008 11.8218 1.08008 8C1.08008 4.17819 4.17819 1.08008 8 1.08008Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.5V8L10.5 9.5",
    stroke: "black",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 13.5L2.5 15",
    stroke: "black",
    strokeWidth: 1.16,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 15L12.5 13.5",
    stroke: "black",
    strokeWidth: 1.16,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 1C2 1.5 1.5 2 1 2.5",
    stroke: "black",
    strokeWidth: 1.16,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 1C14 1.5 14.5 2 15 2.5",
    stroke: "black",
    strokeWidth: 1.16,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.863747ce3648b4b647ca574c79992620.svg";
export { ForwardRef as ReactComponent };